import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Button,
  FormControl,
  FormLabel,
  Text,
  HStack,
  VStack,
} from "@chakra-ui/react";
import { Select } from "chakra-react-select";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { PageContent } from "../../components/PageContent/PageContent";
import { PageHeading } from "../../components/PageHeading/PageHeading";
import { useAdminApiRequest } from "../../hooks/useApiRequest";
import { DMCActiveStatusTable } from "../../components/Report/DMCActiveStatusTable";
import { sortBy } from "lodash";
import { chakraStyles } from "../../components/fields/SelectField/ChakraReactSelectField";
import { useAdminApiClient } from "../../hooks/useApiClient";

export const DMCStatusReport = () => {
  const [selectedBusinesses, setSelectedBusinesses] = useState<string[]>([]);
  const [isDownloadingCsv, setIsDownloadingCsv] = useState(false);

  const adminApiClient = useAdminApiClient();

  const { data: businesses, isLoading: businessLoading } = useAdminApiRequest(
    (client) => client.getBusinesses(""),
    []
  );

  const {
    data: dmcActiveMemberStatuses,
    isLoading: isLoading,
    refresh,
  } = useAdminApiRequest(
    (client) =>
      client.getDigitalMembershipCardActiveMemberStatus({
        businessIds: selectedBusinesses.join(","),
      }),
    []
  );

  const onSelectBusiness = (e: readonly { label: string; value: string }[]) => {
    setSelectedBusinesses(e.map((item) => item.value));
  };

  const downloadCsv = async () => {
    setIsDownloadingCsv(true);
    const response =
      await adminApiClient.getDigitalMembershipCardActiveMemberStatusCsv({
        businessIds: selectedBusinesses.join(","),
      });

    if (response.data) {
      const blobData = new Blob([response.data]);
      const url = URL.createObjectURL(blobData);
      const link = document.createElement("a");
      link.download = `digital-membership-card-active-member-status.csv`;
      link.href = url;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
    setIsDownloadingCsv(false);
  };

  return (
    <>
      <PageHeading>
        <PageHeading.Title>Digital Membership Card Status</PageHeading.Title>
      </PageHeading>
      <PageContent>
        <VStack w="100%" alignItems="flex-start">
          <Breadcrumb variant="pageHeading">
            <BreadcrumbItem>
              <BreadcrumbLink as={Link} to="/admin/reports">
                Reports
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbItem>
              <BreadcrumbLink as={Link} to="/admin/reports/dmc-status">
                Digital Membership Card Status
              </BreadcrumbLink>
            </BreadcrumbItem>
          </Breadcrumb>

          <Text as="h2" fontSize="lg" fontWeight="bold" color="cherryUi.600">
            Reporting Filter:
          </Text>
          <HStack mt={4} w="100%" spacing={6}>
            <FormControl flex={4}>
              <FormLabel>By Business</FormLabel>
              <Select
                isMulti
                options={
                  businesses?.Results.map((item) => {
                    return {
                      label: item.DisplayName!,
                      value: item.Meta!.Id!,
                    };
                  }) || []
                }
                chakraStyles={chakraStyles}
                closeMenuOnSelect={false}
                isLoading={businessLoading}
                placeholder="Select businesses"
                onChange={onSelectBusiness}
              />
            </FormControl>

            <Button
              alignSelf="flex-end"
              colorScheme="cherryButton"
              onClick={refresh}
            >
              Run
            </Button>
            <Button
              marginLeft="4"
              alignSelf={"flex-end"}
              onClick={downloadCsv}
              isLoading={isDownloadingCsv}
            >
              Download
            </Button>
          </HStack>
          <DMCActiveStatusTable
            dmcStatusReports={sortBy(dmcActiveMemberStatuses, ["BusinessName"])}
            isLoading={isLoading}
          />
        </VStack>
      </PageContent>
    </>
  );
};
